// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from 'dayjs';

const DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Transform vehicle from form format to API format
 * Similar to vehicle list create flow
 * @param {Object} vehicle - Vehicle object from form
 * @param {Number} vendorId - Vendor ID to associate with vehicle
 * @returns {Object} Vehicle data in API format
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export const transformVehicleToAPIFormat = (vehicle, vendorId) => {
	const formatDate = (date) => (date ? dayjs(date).format(DATE_FORMAT) : null);

	// vehicle_type is stored as the ID from the Select dropdown
	// Convert it to a number for vehicle_type_id
	const vehicleTypeId =
		vehicle.vehicle_type_id ||
		vehicle.vehicleTypeId ||
		vehicle.vehicle_type ||
		vehicle.vehicleType ||
		null;

	// Validate vehicle_type_id is present
	if (!vehicleTypeId) {
		throw new Error('vehicle_type_id is required');
	}
	if (vehicle.skip_document_upload) {
		return {
			vendor_id: vendorId,
			vehicle_number: vehicle.vehicle_number || vehicle.vehicleNumber || '',
			vehicle_type_id: Number(vehicleTypeId),
			onboard_without_documents: true,
		};
	}

	const gpsInstalled = vehicle.gps_installed === true;
	const gpsFields = { gps_installed: gpsInstalled };
	if (gpsInstalled && (vehicle.gps_provider_name || vehicle.gpsProviderName)) {
		gpsFields.gps_provider_name = vehicle.gps_provider_name || vehicle.gpsProviderName;
	}

	const req_data = {
		vendor_id: vendorId,
		is_active: true,
		vehicle_number: vehicle.vehicle_number || vehicle.vehicleNumber || '',
		vehicle_type_id: Number(vehicleTypeId), // Convert to number
		ownership_type: vehicle.ownership_type || vehicle.ownershipType || 'Own',
		...gpsFields,
		document_info: {
			rc: {
				document_key: vehicle.rc_document_key || vehicle.rcDocumentKey || '',
				valid_till: formatDate(vehicle.rc_valid_till || vehicle.rcExpiryDate),
			},
			insurance: {
				document_key: vehicle.insurance_document_key || vehicle.insuranceDocumentKey || '',
				valid_till: formatDate(
					vehicle.insurance_valid_till || vehicle.insuranceValidityDate
				),
			},
		},
	};

	const pucDocumentKey = vehicle.puc_document_key || vehicle.pucDocumentKey;
	if (pucDocumentKey) {
		req_data.document_info.puc = {
			document_key: pucDocumentKey,
			valid_till: formatDate(vehicle.puc_valid_till || vehicle.pucExpiryDate),
		};
	}

	// Add consent letter if present
	if (vehicle.consent_letter_key || vehicle.consentLetterKey) {
		req_data.document_info.consent_letter = {
			document_key: vehicle.consent_letter_key || vehicle.consentLetterKey,
		};
	}

	return req_data;
};
